import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    const r = await register(form.email, form.password, form.name);
    setLoading(false);
    if (!r.ok) { setError(r.error); return; }
    toast.success("Welcome to Mona's Creations!");
    navigate("/");
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#FFF9F2] rangoli-bg">
      <div className="w-full max-w-md bg-white/90 border border-[#FFD1A6] rounded-3xl p-10 shadow-warm">
        <div className="flex items-center gap-3 mb-2">
          <Flame className="w-6 h-6 text-[#E65C00] diya-flame" />
          <span className="font-display text-2xl text-[#2C1810]">Mona&apos;s Creations</span>
        </div>
        <h1 className="font-display text-4xl text-[#2C1810]">Create your account</h1>
        <p className="font-body text-sm text-[#5B3D2A] mt-2">Join us and light up your celebrations.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label>Name</Label>
            <Input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 bg-white border-[#FFD1A6]" />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 bg-white border-[#FFD1A6]" />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 bg-white border-[#FFD1A6]" />
          </div>
          {error && <div data-testid="reg-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">{error}</div>}
          <Button
            data-testid="reg-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-[#E65C00] hover:bg-[#C44A00] text-white h-12 btn-lift"
          >
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>

        <p className="text-sm font-body text-[#5B3D2A] mt-6 text-center">
          Already have an account?{" "}
          <Link data-testid="reg-to-login" to="/login" className="text-[#4A148C] font-semibold hover:text-[#E65C00]">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
